import { StickyNoteProperties } from "../model/viewModel/stickyNoteProperties";
import { RichText } from "../model/viewModel/richText";
import { useContext } from "react";
import { endBatchAction, startBatchAction } from "../app/undoable";
import { store } from "../app/store";
import { FormContext } from "../context/FormContext";
import { ToolContext } from "../context/ToolContext";
import { findStickyNote, updateStickyNote } from "../app/networkSlice";
import Editor from "./rich-text-editor/Editor";
import { useDispatch, useSelector } from "react-redux";
import { Asset } from "../model/viewModel/asset";

interface StickyNoteFormProps {
  stickyNote: StickyNoteProperties;
}

const StickyNoteForm = ({ stickyNote }: StickyNoteFormProps) => {
  const dispatchRedux = useDispatch();
  const { formState, dispatch } = useContext(FormContext);
  const { toolState } = useContext(ToolContext);
  const { clickedAsset } = toolState as { clickedAsset?: Asset };
  const { clientSettings } = formState;

  const activeStickyNote = useSelector((state) =>
    findStickyNote(state as any, clickedAsset?.id ?? ""),
  );
  const resolvedStickyNote = clickedAsset ? activeStickyNote : stickyNote;
  const assetId = clickedAsset?.id ?? "activeToolId";

  const saveText = (richTexts: RichText[]): void => {
    const name = "richTexts";
    const value = richTexts;

    store.dispatch(startBatchAction());
    try {
      dispatch({
        form: "stickyNoteProperties",
        field: name,
        value: value,
        type: "UPDATE_FIELD",
      });
      if (clickedAsset) {
        dispatchRedux(updateStickyNote({ id: clickedAsset.id, name, value }));
      }
    } finally {
      store.dispatch(endBatchAction());
    }
  };

  return (
    <>
      {clientSettings.features.DebugEnabled && (
        <div>
          <label>DEBUG</label>
          {clickedAsset && clickedAsset.id && (
            <div className="no-gutters row p-3 mb-1 bg-dark">
              <div className="col-4">Asset Id:</div>
              <div className="col">{clickedAsset.id}</div>
            </div>
          )}
        </div>
      )}
      <div className="mb-2" data-testid="sticky-note-form">
        <Editor
          key={`editor-${assetId}`}
          richTexts={resolvedStickyNote?.richTexts ?? []}
          onChange={saveText}
          assetId={assetId}
        />
      </div>
    </>
  );
};

export default StickyNoteForm;
